import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DialogBase} from "app/archivage/deposit/modal/dialog.base";

@Component({
  selector: 'app-dialog-done',
  templateUrl: './dialog-done.component.html',
  styleUrls: ['./dialog-done.component.scss']
})
export class DialogDoneComponent extends DialogBase<DialogDoneComponent> implements OnInit {

  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<DialogDoneComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(dialogRef, data);
  }

  _initForm(): void {
    this.dialogForm = this.formBuilder.group({
      incomingDate: ['', [Validators.required]]
    });
  }
}
